type ConfigProps = {
  maxLength?: number;
};
export const truncateFilename = (fileName: string, config?: ConfigProps) => {
  const { maxLength = 20 } = config || {};
  if (fileName.length > maxLength) {
    const startLength = Math.floor((maxLength - 3) / 2);
    const endLength = Math.ceil((maxLength - 3) / 2);
    const truncatedName =
      fileName.substring(0, startLength) +
      '...' +
      fileName.substring(fileName.length - endLength);
    return truncatedName;
  }

  return fileName;
};
